import WoocommerceAPI from '../IPSAPI/WoocommerceAPI';
import SC_ManageData from './SC_ManageData';
import SidecartControl from './SidecartControl';




//###########################################################################################################################
//#################################################                               ###########################################
//#################################################    HANDLEATTTOCART SIMPLE     ###########################################
//#################################################                               ###########################################
//###########################################################################################################################

export const handleAddToCartSimple = async (
  event: React.MouseEvent<HTMLButtonElement>,
  toggleSidebar: () => void,
  setCurrentProductId: React.Dispatch<React.SetStateAction<string[]>>,
  sidecartSettings: any,
  products: any,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setSpinnerLoading: React.Dispatch<React.SetStateAction<boolean>>
): Promise<void> => {
  console.log("Add to cart simple");
  //console.log("The event: ",event);
  //event.preventDefault();

  const producttyp = 'simple';
  let resultcheck = true;
  const button = event.currentTarget as HTMLButtonElement;


  const ipsproducttyp = extractProductTypeFlags(event.currentTarget);
  

  // Hole Produkt-ID
  let productId: string | null = button.value.trim() || null;

  if (!productId) {
    const productIdInput = document.querySelector('input[name="product_id"]') as HTMLInputElement;
    productId = productIdInput?.value.trim() || null;
  }

  if (!productId) {
    console.warn('Product ID not found');
    return;
  }

  // Setze aktuelle Produkt-ID
  setCurrentProductId((prev) => [...prev, productId]);

  // Hole Menge
  const quantityInput = document.querySelector('.quantity input[type="number"]') as HTMLInputElement;
  const quantityValue = quantityInput?.value || '1';

  // Hole Produkttyp
  //const ipsproducttyp = get_next_producttyp(button);

  // Validierung der Produktvariationen
  const variationSelects = document.querySelectorAll<HTMLSelectElement>('.variations select');
  const allVariationsSelected = Array.from(variationSelects).every((select) => select.value.trim() !== '');

  if (!allVariationsSelected) {
    console.warn('Bitte wählen Sie alle Variationen aus.');
    return;
  }

  // Überprüfung der Cart Gate-Einschränkungen
  if (sidecartSettings.ajaxsidecart === 'on') {
    event.preventDefault();
    event.stopPropagation();
  }

  if (sidecartSettings.enablecartgate === 'on') {
    resultcheck = await SidecartControl.check_RestrictionsLoop({
      productId,
      producttyp,     // "simple"
      ipsproducttyp,   // z.B. "simple, downloadable, gebrauchtware"
      button,
      settings: sidecartSettings,
      cartItems: products,
    });
    //console.log("Resultcheck simple from restrictionloop: ",resultcheck);
  } else {
    resultcheck = true;
  }
  //console.log("Resultcheck simple is: ",resultcheck);

  if (resultcheck && sidecartSettings.cartslider) {
    toggleSidebar();
    await moveAddToCart(productId, quantityValue, producttyp, sidecartSettings, products, setLoading, setSpinnerLoading);
  } else if(!resultcheck){
    //console.warn("Validation failed for product is simple.");
    SidecartControl.destroySidecart(event);
  }
};




//###########################################################################################################################
//#################################################                               ###########################################
//#################################################    HANDLEATTTOCART BUNDLE     ###########################################
//#################################################                               ###########################################
//###########################################################################################################################


export const handleAddToCartBundle = async (
  event: React.MouseEvent<HTMLButtonElement>,
  toggleSidebar: () => void,
  setCurrentProductId: React.Dispatch<React.SetStateAction<string[]>>,
  sidecartSettings: any,
  products: any,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setSpinnerLoading: React.Dispatch<React.SetStateAction<boolean>>
): Promise<void> => {
  console.log("Add to cart bundle");
  //event.preventDefault();

  const producttyp = 'bundle';
  let resultcheck = true;

  // Hole das aktuelle Button-Element
  const button = event.currentTarget as HTMLButtonElement;

  const ipsproducttyp = extractProductTypeFlags(event.currentTarget);

  //console.log("WooCommerce-Typ:", wcType);
  //console.log("Downloadable:", isDownloadable);
  //console.log("Virtual:", isVirtual);

  // Hole Produkt-ID
  let productId: string | null = button.value.trim() || null;
  if (!productId) {
    const productIdInput = document.querySelector('input[name="product_id"]') as HTMLInputElement;
    productId = productIdInput?.value.trim() || null;
  }

  if (!productId) {
    console.warn('Product ID not found for bundle');
    return;
  }

  // Setze aktuelle Produkt-ID
  setCurrentProductId((prev) => [...prev, productId]);

  // Hole Menge
  const quantityInput = document.querySelector('.quantity input[type="number"]') as HTMLInputElement;
  const quantityValue = quantityInput?.value || '1';

  // Hole Produkttyp
  //const ipsproducttyp = get_next_producttyp(button);

  // Hole Variationen
  const selectedOptions: { attribute: string; value: string }[] = [];
  const variationSelects = document.querySelectorAll<HTMLSelectElement>('.variations select');
  variationSelects.forEach((select) => {
    const attributeName = select.getAttribute('data-attribute_name') || '';
    const selectedValue = select.value.trim();
    if (attributeName && selectedValue) {
      selectedOptions.push({ attribute: attributeName, value: selectedValue });
    }
  });

  // Überprüfen, ob alle Variationen ausgewählt sind
  const allVariationsSelected = selectedOptions.length === variationSelects.length;
  if (!allVariationsSelected) {
    console.warn('Bitte wählen Sie alle Variationen aus.');
    return;
  }

  // Überprüfung der Cart Gate-Einschränkungen
  if (sidecartSettings.ajaxsidecart === 'on') {
    event.preventDefault();
    event.stopPropagation();
  }

  if (sidecartSettings.enablecartgate === 'on') {
    resultcheck = await SidecartControl.check_RestrictionsLoop({
      productId,
      producttyp,
      ipsproducttyp,
      button,
      settings: sidecartSettings,
      cartItems: products,
    });
  } else {
    resultcheck = true;
  }

  // Wenn validiert, Sidebar öffnen und Produkt hinzufügen
  if (resultcheck && sidecartSettings.cartslider) {
    toggleSidebar();
    await moveAddToCart(productId, quantityValue, producttyp, sidecartSettings, products, setLoading, setSpinnerLoading, selectedOptions);
  }else if(!resultcheck){
    SidecartControl.destroySidecart(event);
  }
};




//###########################################################################################################################
//#################################################                               ###########################################
//#################################################   HANDLEATTTOCART VARIATION   ###########################################
//#################################################                               ###########################################
//###########################################################################################################################


export const handleAddToCartVariation = async (
  event: React.MouseEvent<HTMLButtonElement>,
  toggleSidebar: () => void,
  setCurrentProductId: React.Dispatch<React.SetStateAction<string[]>>,
  sidecartSettings: any,
  products: any,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setSpinnerLoading: React.Dispatch<React.SetStateAction<boolean>>
): Promise<void> => {
  console.log("IPS ADD-TO-CART VARIATION");

  const producttyp = 'variable';
  let resultcheck = true;

  // Hole das aktuelle Button-Element
  const button = event.currentTarget as HTMLButtonElement;


  const ipsproducttyp = extractProductTypeFlags(event.currentTarget);

  //console.log("WooCommerce-Typ:", wcType);
  //console.log("Downloadable:", isDownloadable);
  //console.log("Virtual:", isVirtual);

  // Hole Produkt-ID
  let productId: string | null = button.value.trim() || null;
  if (!productId) {
    const productIdInput = document.querySelector('input[name="product_id"]') as HTMLInputElement;
    productId = productIdInput?.value.trim() || null;
  }

  if (!productId) {
    console.warn("Product ID not found for variation");
    return;
  }

  // Setze aktuelle Produkt-ID
  setCurrentProductId((prev) => [...prev, productId]);

  // Hole Menge
  const quantityInput = document.querySelector('.quantity input[type="number"]') as HTMLInputElement;
  const quantityValue = quantityInput?.value || '1';

  // Hole Produkttyp
  //const ipsproducttyp = get_next_producttyp(button);

  // Hole FormData
  const form = document.querySelector('.variations_form.cart') as HTMLFormElement;
  const formData = new FormData(form);

  // Validierung: Alle Variationen müssen ausgewählt sein
  const variationSelects = document.querySelectorAll<HTMLSelectElement>('.variations_form select');
  const allVariationsSelected = Array.from(variationSelects).every((select) => select.value.trim() !== '');

  if (!allVariationsSelected) {
    console.warn('Bitte wählen Sie alle Variationen aus.');
    return;
  }

  // Überprüfung der Cart Gate-Einschränkungen
  if (sidecartSettings.ajaxsidecart === 'on') {
    event.preventDefault();
    event.stopPropagation();
  }

  if (sidecartSettings.enablecartgate === 'on') {
    resultcheck = await SidecartControl.check_RestrictionsLoop({
      productId,
      producttyp,
      ipsproducttyp,
      button,
      settings: sidecartSettings,
      cartItems: products,
    });
  } else {
    resultcheck = true;
  }

  // Wenn validiert, Sidebar öffnen und Produkt hinzufügen
  if (resultcheck && sidecartSettings.cartslider) {
    toggleSidebar();
    await moveAddToCart(
      productId,
      quantityValue,
      producttyp,
      sidecartSettings,
      products,
      setLoading,
      setSpinnerLoading,
      null,
      formData
    );
  }else if(!resultcheck){
    SidecartControl.destroySidecart(event);
  }
};



//###########################################################################################################################
//#################################################                               ###########################################
//#################################################  HANDLEATTTOCART EventTicket  ###########################################
//#################################################                               ###########################################
//###########################################################################################################################


export const handleAddToCartEventTicket = async (
  event: React.MouseEvent<HTMLButtonElement>,
  toggleSidebar: () => void,
  setCurrentProductId: React.Dispatch<React.SetStateAction<string[]>>,
  sidecartSettings: any,
  products: any,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setSpinnerLoading: React.Dispatch<React.SetStateAction<boolean>>
): Promise<void> => {
  console.log("IPS ADD-TO-CART ticket-event");

  const producttyp = 'ticket-event';
  let resultcheck = true;

  const button = event.currentTarget;
  const form = button.closest('form');

  if (!form) {
    console.warn("Form not found for ticket-event");
    return;
  }

  const ipsproducttyp = extractProductTypeFlags(event.currentTarget);

 
  const formData = new FormData(form);
  const productId = formData.get('add-to-cart') as string;

  if (!productId) {
    console.warn("Product ID not found in ticket-event form");
    return;
  }

  setCurrentProductId((prev) => [...prev, productId]);

  //const ipsproducttyp = get_next_producttyp(button);

  if (sidecartSettings.ajaxsidecart === 'on') {
    event.preventDefault();
  }

  if (sidecartSettings.enablecartgate === 'on') {
    resultcheck = await SidecartControl.check_RestrictionsLoop({
      productId,
      producttyp,
      ipsproducttyp,
      button,
      settings: sidecartSettings,
      cartItems: products,
    });
  }

  if (resultcheck && sidecartSettings.cartslider) {
    toggleSidebar();
    await moveAjaxAddToCart(formData, sidecartSettings.base_url, sidecartSettings.wc_ajax_url, setLoading);
  }else if(!resultcheck){
    SidecartControl.destroySidecart(event);
  }
};



//###########################################################################################################################
//#################################################                                   #######################################
//#################################################   HANDLEATTTOCART YITHTogether    #######################################
//#################################################                                   #######################################
//###########################################################################################################################


export const handleAddToCartYITHTogether = async (
  event: React.MouseEvent<HTMLButtonElement>,
  toggleSidebar: () => void,
  setCurrentProductId: React.Dispatch<React.SetStateAction<string[]>>,
  sidecartSettings: any,
  products: any,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setSpinnerLoading: React.Dispatch<React.SetStateAction<boolean>>
): Promise<void> => {
  console.log("IPS ADD-TO-CART YITH Together");

  const producttyp = 'YITH-Together';
  let resultcheck = true;
  let productId: string | null = null;
  //let formData: FormData | null = null;

  const button = event.currentTarget;

  const form = button.closest('form.yith-wfbt-form');

  if (!form) {
    console.warn("YITH Together form not found!");
    return;
  }

  const ipsproducttyp = extractProductTypeFlags(event.currentTarget);



  // Dummy Product ID for demonstration
  productId = "123";

  // Ermittlung des Produkttyps
  //const ipsproducttyp = get_next_producttyp(button);

  // Cart-Gate-Validierung, wenn aktiviert
  if (sidecartSettings.ajaxsidecart === 'on') {
    // AJAX-Einschränkungen bei Bedarf
    event.preventDefault();
  }

  if (sidecartSettings.enablecartgate === 'on') {
    resultcheck = await SidecartControl.check_RestrictionsLoop({
      productId,
      producttyp,
      ipsproducttyp,
      button,
      settings: sidecartSettings,
      cartItems: products,
    });
  } else {
    resultcheck = true;
  }

  // Wenn validiert, Sidebar umschalten oder weitere Aktionen ausführen
  if (resultcheck && sidecartSettings.cartslider) {
    toggleSidebar();
    console.log("Add-to-Cart action triggered for YITH Together product.");
    // Hier könnte `moveAjaxAddToCart(formData)` aufgerufen werden, wenn benötigt
  }

  // Prävention bei fehlgeschlagener Validierung
  if (!resultcheck) {
    SidecartControl.destroySidecart(event);
    //console.warn("Validation failed for YITH Together product.");
  }
};



//###########################################################################################################################
//#################################################                               ###########################################
//#################################################     HANDLEATTTOCART SHOP      ###########################################
//#################################################                               ###########################################
//###########################################################################################################################




export const handleAddToCartShop = async (
  event: React.MouseEvent<HTMLButtonElement>,
  toggleSidebar: () => void,
  setCurrentProductId: React.Dispatch<React.SetStateAction<string[]>>,
  sidecartSettings: any,
  products: any,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setSpinnerLoading: React.Dispatch<React.SetStateAction<boolean>>
): Promise<void> => {
  console.log("IPS ADD-TO-CART SHOP");
  event.preventDefault();
  

  const producttyp = 'shop';
  let resultcheck = true;
  const button = event.currentTarget as HTMLButtonElement;

  const ipsproducttyp = extractProductTypeFlags(event.currentTarget);

 

  // Hole Produkt-ID
  let productId = button.dataset.product_id;

  if (!productId) {
    console.warn("Product ID not found for shop");
    return;
  }

  // Setze aktuelle Produkt-ID
  setCurrentProductId((prev) => [...prev, productId]);

  // Hole Menge
  const quantityInput = document.querySelector('.quantity input[type="number"]') as HTMLInputElement;
  const quantityValue = quantityInput?.value || '1';

  // Hole Produkttyp
  //const ipsproducttyp = get_next_producttyp(button);

  // Überprüfung der Cart Gate-Einschränkungen
  if (sidecartSettings.ajaxsidecart === 'on') {
    //console.log("Ajaxsidecart on");
    event.preventDefault();
    event.stopPropagation();

  }




  if (sidecartSettings.enablecartgate === 'on') {
    resultcheck = await SidecartControl.check_RestrictionsLoop({
      productId,
      producttyp,
      ipsproducttyp,
      button,
      settings: sidecartSettings,
      cartItems: products,
    });
    //console.log("Resultcheck shop from restrictionloop: ",resultcheck);
  } else {
    resultcheck = true;
  }

  //console.log("Resultcheck shop is: ",resultcheck);


  if (resultcheck && sidecartSettings.cartslider) {
    toggleSidebar();
    await moveAddToCart(productId, quantityValue, producttyp, sidecartSettings, products, setLoading, setSpinnerLoading);
  } else if(!resultcheck){
    //console.warn("Validation failed for product in shop.");
    SidecartControl.destroyShopSidecart(event);
  }
};



export const moveAddToCart = async (
  productId: string,
  quantity: string,
  producttyp: string,
  sidecartSettings: any,
  products: any,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setSpinnerLoading: React.Dispatch<React.SetStateAction<boolean>>,
  selectedOptions: { attribute: string; value: string }[] | null = null,
  formData: FormData | null = null
): Promise<void> => {
  try {
    const keyID = products?.key || 'none';

    producttyp === 'bundle' || producttyp === 'variable'
      ? setSpinnerLoading(true)
      : setLoading(true);

    const response = await WoocommerceAPI.addToCart(
      sidecartSettings.base_url,
      productId,
      quantity,
      producttyp,
      keyID,
      selectedOptions as unknown as any,
      formData as unknown as any
    );

    producttyp === 'bundle' || producttyp === 'variable'
      ? setSpinnerLoading(false)
      : setLoading(false);

    SC_ManageData.fetchDataDirect(response);
  } catch (error) {
    console.error('Error adding product to cart:', error);
    setLoading(false);
    setSpinnerLoading(false);
  }
};


const moveAjaxAddToCart = async (
  formdata: FormData,
  base_url: string,
  wc_ajax_url: string,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
): Promise<void> => {
  try {
    setLoading(true);
    const response = await WoocommerceAPI.addAjaxToCart(base_url, wc_ajax_url, formdata);
    setLoading(false);
    SC_ManageData.fetchDataDirect(response);
  } catch (error) {
    console.error('Error with Ajax Add to Cart:', error);
    setLoading(false);
  }
};




interface ProductTypeFlags {
  wcType: string;         // z.B. "simple", "variable", "subscription", ...
  isDownloadable: boolean; 
  isVirtual: boolean;
  isUsed: boolean;        // neu
  isDiff: boolean; 
}

export function get_next_producttyp_with_flags(
  button: HTMLElement
): ProductTypeFlags {
  // Standardwerte setzen
  let wcType = 'unknown';
  let isDownloadable = false;
  let isVirtual      = false;
  let isUsed         = false;
  let isDiff         = false;

  // Geschwisterelemente durchsuchen
  let siblingElement = button.nextElementSibling as HTMLElement | null;
  while (siblingElement) {
    if (siblingElement.classList.contains('ips_wooadd_cartcats')) {
      wcType = siblingElement.getAttribute('data-ptyp') || 'unknown';
      isDownloadable = siblingElement.getAttribute('data-downloadable') === 'yes';
      isVirtual      = siblingElement.getAttribute('data-virtual') === 'yes';
      // Neu:
      isUsed         = siblingElement.getAttribute('data-gebrauchtware') === 'yes';
      isDiff         = siblingElement.getAttribute('data-differenzbesteuert') === 'yes';
      return { wcType, isDownloadable, isVirtual, isUsed, isDiff };
    }
    siblingElement = siblingElement.nextElementSibling as HTMLElement | null;
  }

  // Eltern-Container durchsuchen
  let parentElement = button.parentElement as HTMLElement | null;
  while (parentElement) {
    const cartCatsInput = parentElement.querySelector(
      '.ips_wooadd_cartcats'
    ) as HTMLElement | null;

    if (cartCatsInput) {
      wcType = cartCatsInput.getAttribute('data-ptyp') || 'unknown';
      isDownloadable = cartCatsInput.getAttribute('data-downloadable') === 'yes';
      isVirtual      = cartCatsInput.getAttribute('data-virtual') === 'yes';
         // Neu:
         isUsed         = cartCatsInput.getAttribute('data-gebrauchtware') === 'yes';
         isDiff         = cartCatsInput.getAttribute('data-differenzbesteuert') === 'yes';
         return { wcType, isDownloadable, isVirtual, isUsed, isDiff };
    }
    parentElement = parentElement.parentElement as HTMLElement | null;
  }

  // Fallback (nichts gefunden)
  return { wcType, isDownloadable, isVirtual, isUsed, isDiff };
};






/**
 * Extrahiert die Flags des Produkttyps aus dem übergebenen Button-Element.
 * @param button - Das HTML-Element (z.B. event.currentTarget).
 * @returns Ein String, der alle Flags (z.B. "simple, downloadable, gebrauchtware") enthält.
 */
export function extractProductTypeFlags(button: HTMLElement): string {
  const { wcType, isDownloadable, isVirtual, isUsed, isDiff } = get_next_producttyp_with_flags(button);

  // Erzeuge ein Array aller Merkmale
  const flagsArray: string[] = [];
  if (wcType && wcType !== 'unknown') {
    flagsArray.push(wcType);  // z.B. "simple"
  }
  if (isDownloadable) {
    flagsArray.push("downloadable");
  }
  if (isVirtual) {
    flagsArray.push("virtual");
  }
  if (isUsed) {
    flagsArray.push("gebrauchtware");
  }
  if (isDiff) {
    flagsArray.push("differenzbesteuert");
  }

  // Kombiniere die Flags in einen String, den du später mit split(",") auseinandernehmen kannst
  return flagsArray.join(", ");
}




  const get_next_producttyp = (button: HTMLElement): string => {
    let productTyp = "unknown";
  
    // Suche zuerst nach Geschwisterelementen
    let siblingElement = button.nextElementSibling as HTMLElement | null;
    while (siblingElement) {
      if (siblingElement.classList.contains('ips_wooadd_cartcats')) {
        const cartCatsValue = siblingElement.getAttribute('data-ptyp');
        if (cartCatsValue) {
          return cartCatsValue; // Beende die Funktion direkt, wenn der Typ gefunden wurde
        }
      }
      siblingElement = siblingElement.nextElementSibling as HTMLElement | null;
    }
  
    // Wenn kein Geschwisterelement gefunden wurde, suche in den Eltern-Containern
    let parentElement = button.parentElement as HTMLElement | null;
    while (parentElement) {
      const cartProducttypInput = parentElement.querySelector('.ips_wooadd_cartcats') as HTMLElement | null;
      if (cartProducttypInput) {
        const cartProducttypValue = cartProducttypInput.getAttribute('data-ptyp');
        if (cartProducttypValue) {
          return cartProducttypValue; // Beende die Funktion direkt, wenn der Typ gefunden wurde
        }
      }
      parentElement = parentElement.parentElement as HTMLElement | null;
    }
  
    // Gib den Standardwert zurück, wenn nichts gefunden wurde
    return productTyp;
  };

